import styled from "styled-components";

const ProductDetail = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  width: 100%;
  position: relative;
`;
export default ProductDetail;
